module.exports = __webpack_public_path__ + "img/sean.75384b92.png";